import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateBranchProfileDetailsRequest extends BaseUpdateRequest {  
    brandName = '';
    emailAddress = '';
    phoneNumber = '';
    website = '';
    biography = '';
    //avatar: string = '';
}